import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import { LastPage } from "@mui/icons-material";
import React from "react";
import { Tooltip } from "@mui/material";

import { compareVersions } from "./version-utils";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      marginRight: "2px",
    },
    icon: {
      transform: "rotate(-90deg)",
      color: "red",
    },
  })
);

export const ObsoleteFirmware = (props: {
  // Поддержка старого формата (sensor=false)
  defType?: number;
  defVersion: string | number;
  currType?: number;
  currVersion: string | number;
}) => {
  const classes = useStyles();
  const { defType, defVersion, currType, currVersion } = props;

  const isObsolete = defType !== undefined 
    ? defType > currType! || (defType === currType && compareVersions(defVersion, currVersion) > 0)
    : compareVersions(defVersion, currVersion) > 0;

  return (
    <>
      {isObsolete && (
        <Tooltip title={`Прошивка устарела. Дефолтная: ${defVersion}`}>
          <LastPage className={classes.icon} />
        </Tooltip>
      )}
    </>
  );
};
